// extracted by css-extract-rspack-plugin
export default {"iconWrapper":"_feff07dc","icon":"_5a8bc44f","hasUnread":"_e3cf56d7"};